module.exports = __webpack_public_path__ + "static/1-967de36bcc6a22b80eedfcb47b29374d.png";